import React, { useState, useEffect } from 'react';
import { FaChevronUp } from 'react-icons/fa';
import './ScrollToTopButton.scss';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top cordinate to 0
  // make scrolling smooth
  // Custom smooth scroll function for better control and compatibility
  const scrollToTop = () => {
    const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
    
    if (currentScroll > 0) {
      window.requestAnimationFrame(scrollToTop);
      window.scrollTo(0, currentScroll - currentScroll / 15); // Adjust '15' for speed (higher = slower)
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className={`scroll-to-top ${isVisible ? 'visible' : ''}`}>
      <button
        type="button"
        onClick={scrollToTop}
        className="scroll-btn"
        aria-label="Scroll to top"
      >
        <FaChevronUp />
      </button>
    </div>
  );
};

export default ScrollToTopButton;
